import { Component } from '@angular/core';
import { AuthService, StorageService } from '../../shared/service';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, tap } from 'rxjs';
import { UserControlService } from '../../shared/service/userControl/user-control.service';

@Component({
  selector: 'app-accessdenied',
  templateUrl: './app.accessdenied.component.html',
  styleUrls: ['./app.accessdenied.component.scss'],
  standalone :false
})
export class AppAccessdeniedComponent {
  returnTo: string = '';



  constructor(private authService: AuthService,private storageService:StorageService,private userControlService:UserControlService) { 
   forkJoin([
               this.userControlService.getCompanyDetails(),
               this.userControlService.getUserFeaturesWithPrivileges()
             ])
             .pipe(
               tap(([companies,permission]) => {
                 if (companies && permission) {
                   this.authService.logout();
                 }
               })
             )
             .subscribe({
               next: () => {},
               error: err => console.error(err)
             });
  }
  }


